import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import { useEffect, useState } from 'react';
/**
 * Loader component that displays a loading animation.
 */
export function Loader({ className, noDelay, }) {
    const [show, setShow] = useState(noDelay);
    useEffect(() => {
        if (noDelay)
            setShow(true);
        const showDelayTimeout = setTimeout(() => setShow(true), 500);
        return () => clearTimeout(showDelayTimeout);
    }, [noDelay]);
    if (!show) {
        return null;
    }
    return (_jsx("div", { className: clsx('flex h-full items-center justify-center', className), children: _jsxs("div", { className: "flex items-center space-x-2", children: [_jsx("div", { className: "h-3 w-3 animate-pulse rounded-full bg-gray-400" }), _jsx("div", { className: "h-3 w-3 animate-pulse rounded-full bg-gray-400", style: { animationDelay: '300ms' } }), _jsx("div", { className: "h-3 w-3 animate-pulse rounded-full bg-gray-400", style: { animationDelay: '600ms' } })] }) }));
}
